/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useHistory, useLocation } from "react-router";
import Table from '@mui/material/Table';
import { useAxiosLoader } from '../../../plugins/axios'
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import { visuallyHidden } from '@mui/utils';
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TextsmsIcon from '@mui/icons-material/Textsms';
import Tooltip from '@mui/material/Tooltip';
import CreateAppointment from "../create-appointment/create-appointment";
import AddCorrespondenceDialog from "../dialogs/add-correspondence";
import ShowCorrespondenceDialog from "../dialogs/show-correspondence";
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ShowCommunicationHistory from "../dialogs/communication-history"
import HeaderTags from '../../insurance/common/headerTags';
import { exportData } from '../../../services/insurance/common';
import DownloadIcon from '@mui/icons-material/Download';
import moment from 'moment';
import DialogActions from '@mui/material/DialogActions'
import { getContracts, getCorporate, getEntityListForContract, getPackageEntityRelationList, uploadExcelOrders } from '../../../services/insurance/esales';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import Dropzone from 'react-dropzone'
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import { MBContract, USER } from '../../../constants/insurance/constant';
import useWindowDimensions from '../../../constants/GetWindowDimensions/useWindowDimensions';
import CardAccordionEsale from './CardAccordionEsale'
import { URL } from '../../../constants/provider/constant';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}



// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}


//id,requestid, customername, corporatename, appointmentdetails, packagedetails, appointmentdate, appointmentdatetime

const headCells = [
  {
    id: 'Id / eQuote',
    numeric: true,
    disablePadding: false,
    label: 'Id / eQuote',
  },
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: 'Customer Name / Corporate Name'
  },
  {
    id: 'email',
    numeric: true,
    disablePadding: false,
    label: "Phone Number / E-Mail"
  },

  {
    id: 'city',
    numeric: true,
    disablePadding: false,
    label: 'City',
  },
  {
    id: 'state',
    numeric: true,
    disablePadding: false,
    label: 'State',
  },
  {
    id: 'createdon',
    numeric: true,
    disablePadding: false,
    label: 'Created On',
  },
  {
    id: 'actions',
    numric: false,
    disablePadding: false,
  }
  // {
  //   id: 'appointmentdatetime',
  //   numeric: true,
  //   disablePadding: false,
  //   label: 'Appointment Date-Time',
  // }
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow
        className="bg-gray-100"
      >
        {/* <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell> */}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              className="font-bold text-xs"
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        {/* <TableCell
          className="font-bold"
          key={'actions'}
          align={'left'}
          padding={'normal'}
        >
          <span className="font-bold">
             Actions
          </span>
         
        </TableCell> */}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          letiant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%', textAlign: 'center', fontSize: '18px', fontWeight: 600 }}
          letiant="h6"
          id="tableTitle"
          component="div"
          className="py-5"
        >
          ESALES QUEUE
        </Typography>
      )}

      {/* {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )} */}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


export default function AppointmentTable(props) {
  const { setIsMobileView } = props;
  const { width } = useWindowDimensions();
  const [loading] = useAxiosLoader();
  const history = useHistory();
  const location = useLocation()
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('id');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(props.pageNo);
  const [dense] = React.useState(false);
  // const [searchText, setSearchText] = React.useState('');
  const [rowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState(props.rows);
  const [totalRows, setTotalRows] = React.useState(props.totalRows);
  const [rowDetail, setRowDetail] = React.useState()
  const [openDialog, setOpenDialog] = React.useState(false);

  const [openDialogAddCorrespondence, setOpenDialogAddCorrespondence] = React.useState(false);
  const [openDialogShowCorrespondence, setOpenDialogShowCorrespondence] = React.useState(false);
  const [addCorrDetail, setAddCorrDetail] = React.useState();
  const [showCorrDetail, setShowCorrDetail] = React.useState();
  const [openDialogShowCommunicationHistory, setOpenDialogShowCommunicationHistory] = React.useState(false);
  const [communcationHistoryDetails, setCommuncationHistoryDetails] = React.useState();

  const [searchAppointment, setSearchAppointment] = React.useState(props.searchAppointment);

  useEffect(() => {
    if(width <= 768) {
        setIsMobileView(true);
    } 
    if(width > 768) {
        setIsMobileView(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  const handleClickOpenShowCommunicationHistory = (event, rowDetail) => {
    setCommuncationHistoryDetails(rowDetail)
    setOpenDialogShowCommunicationHistory(true);
  }

  const redirectToHistory = (event, name) => {
    history.push("/" + localStorage.getItem("roleName") + "/appointments/esalesqueue/" + name + "/history")
  };


  const handleClickCloseShowCommunicationHistory = () => {
    setOpenDialogShowCommunicationHistory(false);
  }

  const seachDateClicked = () => {
    let data = JSON.parse(localStorage.getItem('pageTracking'));
    data.startTime = dateTimeFirst;
    data.endTime = dateTimeSecond;
    localStorage.setItem('pageTracking', JSON.stringify(data))
    props.onDateSearch(true)
  }

  const handleClickOpenAddCorrespondence = (event, rowDetail) => {
    setAddCorrDetail(rowDetail)
    setOpenDialogAddCorrespondence(true);
  };

  const handleClickCloseAddCorrespondence = () => {
    setOpenDialogAddCorrespondence(false);
  };


  const handleClickOpenShowCorrespondence = (event, rowDetail) => {
    setShowCorrDetail(rowDetail)
    setOpenDialogShowCorrespondence(true);
  };

  const handleClickCloseShowCorrespondence = () => {
    setOpenDialogShowCorrespondence(false);
  };

  const handleClickOpen = (event, rowDetail) => {
    setRowDetail(rowDetail)
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };


  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (props.rows !== rows) {
        setRows(props.rows);
      }
    }
    return () => { isMounted = false };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.rows]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (props.rows !== rows) {
        setPage(props.pageNo);
      }
    }
    return () => { isMounted = false };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.pageNo]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (props.totalRows !== totalRows) {
        setTotalRows(props.totalRows);
      }
    }
    return () => { isMounted = false };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.totalRows]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (props.searchAppointment !== searchAppointment) {
        setSearchAppointment(props.searchAppointment);
      }
    }
    return () => { isMounted = false };
  }, [props.searchAppointment, searchAppointment]);

  const [dateTimeFirst, setDateTimeFirst] = React.useState("");
  const [dateTimeSecond, setDateTimeSecond] = React.useState("");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    props.onChangePage(newPage)
    setPage(newPage);
  };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const requestSearchFirst = (event) => {
    let firstDate = "";
    if (event.target.value === "") {
      firstDate = "";
      setDateTimeFirst(null);
    } else {
      firstDate = new Date(event.target.value);
      setDateTimeFirst(new Date(event.target.value));
      props.onChangeStartDate(firstDate)
    }

    const filteredRows = props.rows.filter((row) => {
      return Object.keys(row).some((field) => {
        let date = new Date(row[field])
        if (field === 'appointmentdate' && event.target.value !== "" && event.target.value != null) {
          if (dateTimeSecond !== "" && dateTimeSecond != null && (date.getTime() >= (firstDate.getTime() - 19800000)) && (date.getTime() <= (dateTimeSecond.getTime() - 19800000))) {
            return true;
          }
          else if (dateTimeSecond === "" && date.getTime() >= (firstDate.getTime() - 19800000)) {
            return true;
          }
          else if (dateTimeSecond == null && date.getTime() >= (firstDate.getTime() - 19800000)) {
            return true;
          }
          else {
            return false;
          }
        }
        else if (field === 'appointmentdate' && dateTimeSecond !== "" && dateTimeSecond != null && date.getTime() <= (dateTimeSecond.getTime() - 19800000)) {
          return true;
        }
        else {
          return false;
        }
      });
    });
    console.log("filteredRows ..", filteredRows)
    if (filteredRows.length !== 0) {
      setRows(filteredRows);
    }
    else {
      setRows(props.rows);
    }

  };

  const RouteToshowAppointment = () => {
    history.push("/" + localStorage.getItem("roleName") + "/appointments");
  }


  const requestSearchSecond = (event) => {
    let second = "";
    if (event.target.value === "") {
      second = "";
      setDateTimeSecond(null);
    } else {
      second = new Date(event.target.value);
      setDateTimeSecond(new Date(event.target.value));
      props.onChangeEndDate(second)
    }
    const filteredRows = props.rows.filter((row) => {
      return Object.keys(row).some((field) => {
        let date = new Date(row[field])
        if (field === 'appointmentdate' && event.target.value !== "" && event.target.value != null) {
          if (dateTimeFirst !== "" && dateTimeFirst != null && (date.getTime() >= (dateTimeFirst.getTime() - 19800000)) && (date.getTime() <= (second.getTime() - 19800000))) {
            return true;
          }
          else if (dateTimeFirst == null && date.getTime() <= (second.getTime() - 19800000)) {
            return true;
          }
          else if (dateTimeFirst === "" && date.getTime() <= (second.getTime() - 19800000)) {
            return true;
          }
          else {
            return false;
          }
        }
        else if (field === 'appointmentdate' && dateTimeFirst != null && dateTimeFirst !== "" && date.getTime() >= (dateTimeFirst.getTime() - 19800000)) {
          return true;
        }
        else {
          return false;
        }
      });
    });
    console.log("filteredRows ..", filteredRows)
    if (filteredRows.length !== 0) {
      setRows(filteredRows);
    }
    else {
      setRows(props.rows);
    }
  }

  const exportDataHandler = () => {
    if (!dateTimeFirst && !dateTimeSecond)
      exportData(searchAppointment, page - 1, moment().subtract(3, 'month').toISOString(), moment().toISOString(), "RequestCreationDate", false);
    else
      exportData(searchAppointment, page - 1, dateTimeFirst, dateTimeSecond, "RequestCreationDate", false);
  }
  // Avoid a layout jump when reaching the last page with empty rows.
  // const emptyRows =
  //   page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const [user] = React.useState(JSON.parse(localStorage.getItem("user_details")))
  const [showBulkCaseCreation, setShowBulkCaseCreation] = React.useState(false)
  const [selectedContract, setSelectedContract] = React.useState(user.properties["Assigned Contracts"])
  const [selectedCorporate, setSelectedCorporate] = React.useState(getCorporate())
  const [file, setFile] = React.useState("")
  const [insType, setInsType] = React.useState("")
  const [errMsg, setErrMsg] = React.useState("")
  const [corporateList, setCorporateList] = React.useState([]);
  const [corporateKeyword, setCorporateKeyword] = React.useState("")
  const [packageEntityRelationList, setPackageEntityRelationList] = React.useState([]);
  const [selectedpackage, setPackage] = React.useState("")
  const [selectedPackage, setSelectedPackage] = React.useState({})
  const [status, setStatus] = React.useState(props.status);
  const [selectedEntity, setSelectedEntity] = useState('');
  const [entityListForContract, setEntityListForContract] = useState([]);
  const [bulkCaseCreationAllowed, setBulkCaseCreationAllowed] = React.useState(false);

  const sources = [
    {
      name: 'Policy Bazar Health',
      value: "1019337"
    },
    {
      name: 'Insurer Agent',
      value: localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")).entityId.toString() : "0"
    }
  ];

  const sourceValue = sources.find(ele => ele.name === "Insurer Agent").value;

  const [source, setSource] = React.useState(sourceValue)


  const contracts = getContracts();

  const getCorporateData = (key) => {
    getCorporate(selectedContract, key)
      .then(res => {
        if (res.isSuccess) {
          return res.corporates.map(ele => {
            ele.label = ele.name;
            return ele
          })
        }

        else return [];
      })
      .then(data => {
        setCorporateList(data)
        if (data && data.length === 1 && key == data[0].name) setSelectedCorporate(data[0]);
      })
      .catch(err => {
        setErrMsg(err)
      })
  }
  const fetchCorporates = (key) => {
    setCorporateKeyword(key)
    getCorporateData(key)
  }
  
  useEffect(() => {
    if (selectedContract == MBContract.TeleUnderwriting) {
      getPackageEntityRelationList({
        EntityRelationIds: [selectedCorporate.id], contractId: selectedContract
      })
        .then(data => {
          if (data.isSuccess) {
            setPackageEntityRelationList(data.packagesTests); /////////////checek response
          }
        })
        .catch(err => console.log(err))
    }
    setEntityListForContract(getEntityListForContract(selectedContract));
  }, [selectedContract,selectedCorporate])

 

  useEffect(() => {
    if (USER?.roleName) {
      setBulkCaseCreationAllowed(
        USER.roleName === "insureradmin" || USER.roleName === "insureragent"
      );
    }
  }, [USER.roleName]);

  useEffect(() => {
    if (selectedContract === MBContract.ESALES || selectedContract === MBContract.PrePolicy) {
      if (entityListForContract && entityListForContract.length > 0) {
        setSelectedEntity(entityListForContract[0].entityName)
      }
    }
  }, [entityListForContract]);

  // const bulkCaseCreationAllowed = ((user.role == 'Insurer_Admin' || user.entityType == 'Corporate' || user.entityType == 'HR') || user.entityType != 'Insurance_Broker' && user.entityType != 'Insurer' && user.entityType != 'Corporate' && user.entityType != 'HR' && selectedContract == 9717 /*&& serverSearch.corporateId*/)
  const handleFieldChange = (file, type) => {
    setFile(file[0])
    setInsType(type);
  }

  const submitBulkCreate = () => {
    const selectedEntityDetails = entityListForContract.find(entity => entity.entityName == selectedEntity);
    let formdata = new FormData();
    formdata.append("sourceId", parseInt(source));
    formdata.append("contractId", selectedContract);
    formdata.append("entityRelationId", selectedEntityDetails.id);
    formdata.append("entityName", selectedEntityDetails.entityName);
    formdata.append("excel_file", file);
    formdata.append("userName", user.firstName);

    if (selectedContract == MBContract.TeleUnderwriting) {
      formdata.append('teleUnderwritingProductId', '' + selectedPackage.productEntityRelationId);
      formdata.append('teleUnderwritingProductName', selectedPackage.packageAliasName);
    }

    if (selectedContract == MBContract.ESALES || selectedContract == MBContract.PrePolicy) {
      formdata.append('uploadedSourceId', '' + parseInt(source));
    }



    uploadExcelOrders(formdata)
      .then(res => {
        if (res && res.isSuccess) {
          if (!res.errorMessage) {
            setShowBulkCaseCreation(false);
            setFile("");
            setSource(sourceValue);
            setErrMsg("");
          }
          else {
            setErrMsg(res.errorMessage);
          }
        }
        else {
          if (res && !res.isSuccess) {
            setErrMsg(res.error && res.error.includes("File is not an excel") ? "File is not an excel or is corrupted." : "Unable to create order.")
          }
        }
      })
      .catch(err => {
        if (err.errorMessage) setErrMsg(err.errorMessage)
      })
  }
  const packageChanged = (e) => {
    setPackage(e);
    packageEntityRelationList.map(ele=>{
      if(ele.productEntityRelationId == e )setSelectedPackage(ele);
    })
  }

  return (
    <Box className="pb-4" sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
      {width > 768 ? (
          <>
        <HeaderTags history={history} page={page} location={location.pathname}></HeaderTags>
        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <div>
          <div className="flex w-full justify-between pb-4 px-4">
            <div className="flex date-filter-dashboard">
              <div>
                <TextField
                  className="w-full"
                  id="date"
                  label="Starting Date"
                  type="date"
                  defaultValue={dateTimeFirst ? dateTimeFirst : ''}
                  onChange={requestSearchFirst}
                  // onChange={() => this.setDateTimePickerFirst()}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div className="ml-2">
                <TextField
                  className="w-full"
                  id="date"
                  label="Ending Date"
                  type="date"
                  defaultValue={dateTimeSecond ? dateTimeSecond : ''}
                  onChange={requestSearchSecond}
                  // onChange={() => this.setDateTimePickerFirst()}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div className="ml-2 search-icon">
                <div className="w-full">
                  <div className="m-auto">
                    <SearchIcon  onClick={seachDateClicked} />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-end">
            {
              bulkCaseCreationAllowed &&
              <div
                className="border border-green-500  hover:bg-green-900 hover:border-green-900 hover:text-gray-100 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-pointer ml-2 my-auto float-right"
                onClick={() => setShowBulkCaseCreation(true)}>
                Bulk Case Creation
              </div>
            }
            {
              rows.length > 0 ?
                <div className="border border-blue-400  hover:bg-blue-600 hover:border-blue-600 hover:text-gray-100 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-pointer ml-2 my-auto" onClick={() => exportDataHandler()}>
                  Export
                  <span className="pl-1 font-svg-xxs">
                    <DownloadIcon></DownloadIcon>
                  </span>
                </div>
                :
                <></>
            }
            </div>
          </div>
        </div>

        <div className='appointment-wrapper'>
          <TableContainer>
            {loading ? <LinearProgress /> : ''}
            <Table
              sx={{ minWidth: 750 }}
              className="text-sm"
              aria-labelledby="tableTitle"
              size={dense ? 'small' : 'medium'}
            ><EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              <TableBody>
                {/* if you don't need to support IE11, you can replace the `stableSort` call with:
          rows.slice().sort(getComparator(order, orderBy)) */}
                {rows.length > 0 ? stableSort(rows, getComparator(order, orderBy))
                  .slice(0 * rowsPerPage, 0 * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row.name);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow
                        hover
                        className="cursor-pointer"
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={index}
                        selected={isItemSelected}
                      >{/* <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            onClick={(event) => handleClick(event, row.requestid)}
                            checked={isItemSelected}
                            inputProps={{
                              'aria-labelledby': labelId,
                            }}
                          />
                        </TableCell> */}
                        <TableCell
                          align="left"
                          component="th"
                          id={labelId}
                          scope="row"
                          className="cursor-pointer"
                        >
                          <div className="text-blue-600 font-semibold">
                            <span className='mr-1' onClick={(event) => redirectToHistory(event, row.Id)}>{row.Id}</span>
                          </div>

                          <div className="text-gray-500 text-xs">
                            {row.eQuote}
                          </div>
                        </TableCell>
                        <TableCell className="text-xs" align="left">{row.name}
                          <div className="text-gray-500 text-xs">{row.corporatename}</div>
                        </TableCell>
                        <TableCell align="left">
                          <div className=" text-sm">{row.phoneNo}</div>
                          <div className="text-gray-500 text-xs">{row.email}</div>
                        </TableCell>
                        <TableCell className="text-xs" align="left">{row.city}</TableCell>
                        <TableCell className="text-xs" align="left">{row.state}</TableCell>
                        <TableCell className="text-xs" align="left">{row.createdOn}
                          <div className="text-gray-500 text-xs">{row.createdTime}</div>
                        </TableCell>
                        <TableCell className="text-xs" align="left">
                          <div className="flex justify-around">
                            <div className="text-gray-500 text-blue-400">
                              <Tooltip title="Add Correspondence" placement="bottom-end">
                                <AddIcon onClick={(event) => handleClickOpenAddCorrespondence(event, row.allData)} />
                              </Tooltip>
                            </div>
                            <div className="text-gray-500 pl-1 pr-2 text-green-500">
                              <Tooltip title="Show Correspondence" placement="bottom">
                                <VisibilityIcon onClick={(event) => handleClickOpenShowCorrespondence(event, row.allData)} />
                              </Tooltip>
                            </div>
                            {/* <div className="text-gray-500  pr-2 text-blue-500">
                              <Tooltip title="Create Appointment" placement="bottom">
                                <HotelIcon onClick={(event) => handleClickOpen(event, row.allData)} />
                              </Tooltip>
                            </div> */}
                            <div className="text-gray-500 text-gray-600">
                              <Tooltip title="Communication History" placement="bottom-end">
                                <TextsmsIcon onClick={(event) => handleClickOpenShowCommunicationHistory(event, row.allData)} />
                              </Tooltip>
                            </div>

                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  }) : null}
                {/* {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )} */}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        </>
        ) : <></>}
        { width <= 768 ? (
              <div className='appointment-wrapper'>
                  {loading ? <LinearProgress /> : ''}
                  <ul>
                      <li className='pd-hr-xs-15'>
                          <div className="flex date-filter-dashboard js-sp-bt-xs">
                              <div className='date-filter-input'>
                                  <TextField
                                      className="w-full"
                                      id="date"
                                      label="Starting Date"
                                      type="date"
                                      value={dateTimeFirst ? dateTimeFirst : ''}
                                      onChange={requestSearchFirst}
                                      InputLabelProps={{
                                          shrink: true,
                                      }}
                                  />
                              </div>
                              <div className="ml-2 date-filter-input">
                                  <TextField
                                      className="w-full"
                                      id="date"
                                      label="Ending Date"
                                      type="date"
                                      value={dateTimeSecond ? dateTimeSecond : ''}
                                      onChange={requestSearchSecond}
                                      InputLabelProps={{
                                          shrink: true,
                                      }}
                                  />
                              </div>
                              <div className="ml-2 search-icon">
                                  <div className="w-full">
                                      <div className="m-auto">
                                          <SearchIcon onClick={seachDateClicked} />
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </li>
                      <li className='pd-hr-xs-15'>
                          <div className='flex justify-between'>
                            {
                                bulkCaseCreationAllowed &&
                                <div
                                  className="border border-green-500  hover:bg-green-900 hover:border-green-900 hover:text-gray-100 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-pointer ml-2 my-auto float-right"
                                  onClick={() => setShowBulkCaseCreation(true)}>
                                  Bulk Case Creation
                                </div>
                              }
                              <div className='export-btn'>
                                  {
                                      rows.length > 0 ?
                                          <div className="border border-blue-400  hover:bg-blue-600 hover:border-blue-600 hover:text-gray-100 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-pointer ml-2 my-auto" onClick={() =>exportDataHandler()}>
                                              Export
                                              <span className="pl-1 font-svg-xxs">
                                                  <DownloadIcon></DownloadIcon>
                                              </span>
                                          </div>
                                      :
                                      <></>
                                  }
                              </div>
                          </div>
                      </li>
                      {rows.length ? rows.map((row, index) => (
                          <li className="pd-hr-xs-15 pd-bt-xs-15" key={index}>
                              <CardAccordionEsale
                                  isSelected={isSelected}
                                  row={row}
                                  redirectToHistory={() => {}}
                                  index={index}
                                  status={status}
                                  pageName={["confirmed", "notAttended"]}
                                  handleClickOpenShowCommunicationHistory={handleClickOpenShowCommunicationHistory}
                                  handleClickOpenAddCorrespondence={handleClickOpenAddCorrespondence}
                                  handleClickOpenShowCorrespondence={handleClickOpenShowCorrespondence}
                              />
                          </li>)
                      )
                      : <></>
                      }
                      
                  </ul>
              </div>
          )
          :<></>
        }
        { }
        <Stack spacing={2} className="p-2">
          <div className="flex justify-between">
            <div className="pt-2">
              <span className="text-gray-400 text-sm">
                Total Counts :
              </span>
              <span className="text-gray-400 pl-2 font-semibold text-sm">
                {totalRows}
              </span></div>
            <div>
              <Pagination count={parseInt(totalRows / 10) + 1} boundaryCount={4} showFirstButton={true} showLastButton={true} page={page} onChange={handleChangePage} />
            </div>
          </div>
        </Stack>
      </Paper>

      <Dialog
        open={Boolean(showBulkCaseCreation && (selectedContract || contracts.length > 0))}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            setShowBulkCaseCreation(false);
            setSource(sourceValue);
            setErrMsg("")
            setFile("")
          } else return false;
        }}
        // minHeight={"500px"}
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle className='border-b-2'>
          <p className=''>Bulk Case Creation <span className='float-right mr-2 cursor-pointer' onClick={() => {
            setShowBulkCaseCreation(false);
            setSource(sourceValue);
            setErrMsg("")
            setFile("")
          }}><CloseIcon/></span></p>
          
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <div className='mt-3'>
            {
              !JSON.parse(localStorage.getItem("user_details")).properties["Assigned Contracts"] &&
              <div className='my-3'>
                <FormControl variant="filled" sx={{ m: 0, width: 300 }} className="border rounded-full">
                    <InputLabel id="contractLabel">Select Contract</InputLabel>
                    <Select
                      labelId='contractLabel'
                      label='Contract'
                      value={selectedContract}
                      onChange={(e) =>{ setCorporateKeyword("");  setSelectedContract(e.target.value);setCorporateList([]); setSelectedCorporate({}); setSelectedEntity('')}}
                    >
                      {
                        contracts.map(ele => {
                          return <MenuItem value={ele.id}>{ele.entityName}</MenuItem>
                        })
                      }
                    </Select>
                  </FormControl>
              </div>
            }
          </div>
          {/* <div>

            <Autocomplete
              sx={{
                display: 'inline-block',
                width:"300px",
                '& input': {
                '& input': {
                  width: '300px',
                  borderRadius: '5px',
                  padding: '7px',
                  cursor: "pointer",
                },

              }}
              options={corporateList ? corporateList : []}
              inputValue={corporateKeyword ? corporateKeyword : ''}
              onClick={(e)=>console.log(e)}
              onchange={(e, val) => console.log(e)}
              onInputChange={(_, newInputValue) => {
                fetchCorporates(newInputValue)
              }}
              renderInput={(params) => (
                <div ref={params.InputProps.ref} className="flex relative">
                  <TextField type="text" {...params.inputProps} placeholder='Select Corporate'  />
                </div>

              )}
            />

          </div> */}
          <div className='w-full'>
            <div className='flex justify-between'>
              {
                (selectedContract == MBContract.ESALES || selectedContract == MBContract.PrePolicy) &&
                <div className='my-3'>
                  <FormControl className="less-padding-select" sx={{width:200, m:0}}>
                    <InputLabel id="sourceLabel">Select Source</InputLabel>
                    <Select
                      labelId='sourceLabel'
                      label='SelectSource'
                      value={source}
                      onChange={(e) => setSource(e.target.value)}
                    >
                      {
                        sources.map(ele => {
                          return <MenuItem value={ele.value}>{ele.name}</MenuItem>
                        })
                      }
                    </Select>
                  </FormControl>
                </div>
              }
              {
                selectedContract &&
                <div className='my-3'>
                  <FormControl className="less-padding-select" sx={{width:200, m:0}}>
                    <InputLabel id="entityLabel">Select Entity</InputLabel>
                    <Select
                      labelId='entityLabel'
                      label='SelectEntity'
                      value={selectedEntity}
                      onChange={(e) => setSelectedEntity(e.target.value)}
                    >
                      {
                        entityListForContract.map(ele => {
                          return <MenuItem value={ele.entityName}>{ele.entityName}</MenuItem>
                        })
                      }
                    </Select>
                  </FormControl>
                </div>
              }
              {
                selectedContract == MBContract.TeleUnderwriting
                &&
                <div className='my-3'>
                  <FormControl className="less-padding-select" sx={{width:200, m:0}}>
                    <InputLabel id="packageLabel">Select Package</InputLabel>
                    <Select
                      labelId='packageLabel'
                      label='Select Package'
                      value={selectedpackage}
                      onChange={(e) =>{ packageChanged(e.target.value);//setPackage(e.target.value); //setSelectedPackage(e.target.value) ;
                      }}
                    >
                      {
                        packageEntityRelationList && packageEntityRelationList[0] && packageEntityRelationList.map(ele => {
                          return <MenuItem value={ele.productEntityRelationId}>{ele.packageAliasName}</MenuItem>
                        })
                      }
                    </Select>
                  </FormControl>
                </div>
              }
              {
                selectedContract && (selectedContract == MBContract.PreEmployment ||
                  selectedContract == MBContract.ESALES ||
                  selectedContract == MBContract.PrePolicy ||
                  selectedContract == MBContract.DrugTest ||
                  selectedContract == MBContract.TeleUnderwriting ||
                  selectedContract == MBContract.CONSUMABLES) &&
                <a href={URL.providercore_url + "insurance/downloadSampleFormat?contractId=" + selectedContract} download >
                  <div className="border border-blue-400  hover:bg-blue-600 hover:border-blue-600 hover:text-gray-100 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-pointer ml-2 my-auto" onClick={() => exportDataHandler()}>
                   Download Template
                  <span className="pl-1 font-svg-xxs">
                    <DownloadIcon></DownloadIcon>
                  </span>
                </div>
                </a>
              }
            </div>
            <div className='px-4 pt-8 grid justify-items-center'>
              <div className='border border-dashed border-gray-500 w-full bg-gradient-to-l from-blue-100 via-gray-100 to-blue-100 grid justify-items-center h-32 rounded-lg pt-6'>
                <Dropzone onDrop={file => handleFieldChange(file, "case1")}>
                  {({ getRootProps, getInputProps }) => (
                    <section>
                      <div {...getRootProps()}>
                        <div className="text-blue-700 cursor-pointer btn  border border-blue-700 font-blue-700 px-3 py-1 rounded text-center" style={{ fontSize: "0.9rem" }}>
                          <p>Drag 'n' drop some files here, or click to select files</p><FileUploadIcon></FileUploadIcon>
                        </div>
                        <input {...{ ...getInputProps(), multiple: false }} />
                      </div>
                    </section>
                  )
                  }
                </Dropzone>

                <div className='w-1/2 grid justify-items-center mt-2'>
                  <span className="text-sm font-semibold">{file && file.name}</span>
                </div>

              </div>
            </div>
          </div>

        </DialogContent>
        <DialogActions>
          <div className="w-full m-auto pb-4">
          {
            (file && (source != "") && selectedContract && (selectedCorporate != {}) && selectedEntity || 
            (file && (source != "") && selectedContract && (selectedCorporate != {}) && selectedContract == MBContract.TeleUnderwriting && selectedPackage!= {} )) &&
            <div
              className="m-auto bg-blue-500 rounded-md w-40 text-center text-gray-100 p-1 cursor-pointer font-semibold"
              onClick={() => submitBulkCreate()}
             >
              <span>
                Submit
              </span>
            </div>
          }
           {
            errMsg &&
            <div className='w-full m-auto text-center pt-2'>
              <span className='text-red-500 text-md' >{errMsg}</span>
            </div>
          }
          </div>

         
        </DialogActions>
      </Dialog>


      <Dialog
        open={openDialogAddCorrespondence}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClickCloseAddCorrespondence()
          } else return false;
        }}
        fullWidth={true}
        maxWidth={'sm'}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ background: "rgb(245 245 245)" }}>
          <div className="flex justify-between">
            <div className="font-semibold">
              <span className="cursor-pointer">
                Add Correspondence
              </span>
              {
                addCorrDetail ? <div className="text-xs text-gray-500">
                  EQoute ID <span className="font-semibold">{addCorrDetail.eQuote} </span>
                </div> : <></>
              }

            </div>
            <div className="text-gray-500" onClick={handleClickCloseAddCorrespondence}>
              <span className="cursor-pointer">
                <CloseIcon></CloseIcon>
              </span>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <AddCorrespondenceDialog details={addCorrDetail} closeDialog={(event) => handleClickCloseAddCorrespondence(event)}></AddCorrespondenceDialog>
        </DialogContent>
      </Dialog>


      <Dialog
        open={openDialogShowCorrespondence}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClickCloseShowCorrespondence()
          } else return false;
        }}
        fullWidth={true}
        maxWidth={'md'}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ background: "rgb(245 245 245)" }}>
          <div className="flex justify-between">
            <div className="font-semibold">
              <span className="cursor-pointer">
                Show Correspondence
              </span>
              {
                showCorrDetail ?
                  <div className="text-xs text-gray-500">
                    EQoute ID <span className="font-semibold">{showCorrDetail.eQuote} </span>
                  </div> : <></>
              }

            </div>
            <div className="text-gray-500" onClick={handleClickCloseShowCorrespondence}>
              <span className="cursor-pointer">
                <CloseIcon></CloseIcon>
              </span>
            </div>
          </div>

        </DialogTitle>
        <DialogContent>
          <ShowCorrespondenceDialog details={showCorrDetail} closeDialog={(event) => handleClickCloseShowCorrespondence(event)}></ShowCorrespondenceDialog>
        </DialogContent>
      </Dialog>



      <Dialog
        open={openDialogShowCommunicationHistory}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClickCloseShowCommunicationHistory()
          } else return false;
        }}
        fullWidth={true}
        maxWidth={'md'}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ background: "rgb(245 245 245)" }}>
          <div className="flex justify-between">
            <div className="font-semibold">
              <span className="cursor-pointer">
                Communication History
              </span>
              {
                communcationHistoryDetails ?
                  <div className="text-xs text-gray-500">
                    EQoute ID <span className="font-semibold">{communcationHistoryDetails.eQuote} </span>
                  </div> : <></>
              }

            </div>
            <div className="text-gray-500" onClick={handleClickCloseShowCommunicationHistory}>
              <span className="cursor-pointer">
                <CloseIcon></CloseIcon>
              </span>
            </div>
          </div>

        </DialogTitle>
        <DialogContent>
          <ShowCommunicationHistory details={communcationHistoryDetails} closeDialog={(event) => handleClickCloseShowCommunicationHistory(event)}></ShowCommunicationHistory>
        </DialogContent>
      </Dialog>


      <Dialog
        open={openDialog}
        fullWidth={true}
        maxWidth={'md'}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClose()
          } else return false;
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ background: "rgb(245 245 245)" }}>
          <div className="flex justify-between">
            <div className="font-semibold">
              <span className="cursor-pointer">
                Create Appointment
              </span>
              {
                rowDetail ?
                  <div className="text-xs text-gray-500">
                    EQoute ID <span className="font-semibold">{rowDetail.eQuote} </span>
                  </div> : <></>
              }

            </div>
            <div className="text-gray-500" onClick={handleClose}>
              <span className="cursor-pointer">
                <CloseIcon></CloseIcon>
              </span>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <CreateAppointment createAppointmentFor={'ESALES'} dialogModal={true} esalesValue={rowDetail}></CreateAppointment>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
